export default {
  textField: {
    '& .MuiInputBase-root': {
      backgroundColor: '#F5F5F5',
      borderRadius: 10,
      fontSize: '16px',
      fontWeight: 400,
      pr: 2,
      width: 360,
      '&::placeholder': {
        color: '#737373',
        opacity: 1,
      },
    },
    '& .MuiInputBase-input': {
      pl: 2,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#DFDFDF',
    },
  },
  searchIcon: {
    m: 0,
    '& svg': {
      height: 16,
      minHeight: 16,
      minWidth: 16,
      width: 16,
    },
  },
};
